export class InputManager {
  constructor() {
    this.keys = {};
    this.mouseButtons = {};
    this.mouseDX = 0;
    this.mouseDY = 0;
    this._pendingDX = 0;
    this._pendingDY = 0;
    this._mouseJustPressed = {};

    document.addEventListener('keydown', (e) => {
      this.keys[e.code] = true;
    });
    document.addEventListener('keyup', (e) => {
      this.keys[e.code] = false;
    });
    document.addEventListener('mousemove', (e) => {
      this._pendingDX += e.movementX;
      this._pendingDY += e.movementY;
    });
    document.addEventListener('mousedown', (e) => {
      this.mouseButtons[e.button] = true;
      this._mouseJustPressed[e.button] = true;
    });
    document.addEventListener('mouseup', (e) => {
      this.mouseButtons[e.button] = false;
    });
  }

  update() {
    this.mouseDX = this._pendingDX;
    this.mouseDY = this._pendingDY;
    this._pendingDX = 0;
    this._pendingDY = 0;
  }

  consumeClick(button) {
    if (this._mouseJustPressed[button]) {
      this._mouseJustPressed[button] = false;
      return true;
    }
    return false;
  }

  isKeyDown(code) {
    return !!this.keys[code];
  }

  isMouseDown(button) {
    return !!this.mouseButtons[button];
  }

  // Touch controls support
  _simulateKey(code, pressed) {
    this.keys[code] = pressed;
  }

  _simulateClick(button) {
    this.mouseButtons[button] = true;
    this._mouseJustPressed[button] = true;
    // Auto-release after 100ms
    setTimeout(() => { this.mouseButtons[button] = false; }, 100);
  }
}
